import React from "react"
import {Container, Row} from "react-bootstrap"
import { IoIosCloseCircle } from "react-icons/io";
import "../../assets/css/virtual-fair-header.css"
import logo from "../../assets/images/logo-white.svg"
import sponsered from "../../assets/images/sponsered.png"

const HeaderVirtualFair = ({handlePopup})=>{
    const popup = (isShow)=>{
        handlePopup(isShow)
    }
    return(
        <header className="header_virtual_fair">
            <span
                onClick={()=>popup(true)}
                className="close_idp"
             ><IoIosCloseCircle/></span>
            <Container>
                <img className="logo_virtual_fair" src={logo} alt="logo" />
                <div className="heading_group">
                    <h3>Presents</h3>
                    <h2>India’s BIGGEST</h2>
                    <h1>Liberal Arts & Sciences Expo (LASE)</h1>
                    <div className="date">
                        Date <span>6th & 7th July</span>
                    </div>
                </div>
                <p>Join us for the largest gathering of students, universities, and experts in Liberal Arts and Sciences. Explore diverse undergraduate programs including BA, BSc, BCom, BBA, BDes, and Media studies.</p>
                <div className="sponsered_by">
                    <p>Sponsored by</p>
                    <div><img src={sponsered} alt="Amity"/></div>
                </div>
            </Container>
        </header>
    )
}

export default HeaderVirtualFair